import { render, staticRenderFns } from "./Bloco8Transparencia.vue?vue&type=template&id=41556346&scoped=true&"
import script from "./Bloco8Transparencia.vue?vue&type=script&lang=js&"
export * from "./Bloco8Transparencia.vue?vue&type=script&lang=js&"
import style0 from "./Bloco8Transparencia.vue?vue&type=style&index=0&id=41556346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41556346",
  null
  
)

export default component.exports